<script lang="ts" setup>
const props = defineProps<{
  data?: {
    hero_image?: DirectusFile
    hero_video?: DirectusFile
    translations: DirectusTranslation<{
      title: string
      intro_text: string
      button_text?: string
      button_url?: string
    }>
  }
}>()

const config = useRuntimeConfig()
const { dt } = useDirectusTranslation()
const { hyphen } = useHyphen()

const videoAssetRoot = `${config.public.directus.remote_file_storage}/`
</script>

<template>
  <div>
    <BlockBase v-if="props.data">
      <div class="relative min-h-screen flex flex-col bg-starline-secondary">
        <div v-if="props.data.hero_image" class="pointer-events-none absolute inset-0">
          <NuxtPicture
            provider="directus"
            :src="props.data.hero_image.id"
            alt=""
            class="h-full w-full"
            :img-attrs="{
              class: 'h-full w-full object-cover',
            }"
          />
        </div>
        <div v-if="props.data.hero_video" class="pointer-events-none absolute inset-0">
          <video disablepictureinpicture playsinline muted loop autoplay class="h-full w-full object-cover">
            <source :src="videoAssetRoot + props.data.hero_video.filename_disk" :type="props.data.hero_video.type">
          </video>
        </div>
        <div class="pointer-events-none absolute inset-0 bg-starline-secondary/60" />
        <div class="hero-gradient pointer-events-none absolute inset-0" />
        <Container class="relative mt-auto pt-12rem">
          <h1
            class="mb-2rem max-w-85rem text-balance textH1 text-neutral-white"
          >
            {{ hyphen(dt(props.data.translations)?.title) }}
          </h1>
          <div class="wrap mb-8rem w-full flex flex-wrap items-end justify-between gap-4rem">
            <p class="mt-4rem max-w-4xl whitespace-pre-line border-l border-neutral-white pl-3rem text-balance text-1.6rem">
              {{ dt(props.data.translations)?.intro_text }}
            </p>
            <BtnPrimary
              v-if="dt(props.data.translations)?.button_text && dt(props.data.translations)?.button_url"
              :text="dt(props.data.translations)?.button_text ?? ''"
              :link="dt(props.data.translations)?.button_url ?? ''"
            />
          </div>
        </Container>
      </div>
    </BlockBase>
  </div>
</template>

<style scoped>
.hero-gradient {
  background:
    linear-gradient(180deg, #000b1a 0%, rgba(0, 11, 26, 0) 32.29%),
    linear-gradient(0deg, #000b1a 1.88%, rgba(0, 11, 26, 0) 29.15%);
}
</style>
